// ============================================================
// หน้า CapitalPaymentInfo — ข้อมูลการรับชำระเงินทุน
// ------------------------------------------------------------
// ดูรายการรับชำระที่แยกตาม "รหัสรายการรับชำระ" (เช่น เงินกองทุน เงินประกัน)
// และสั่งพิมพ์ใบเสร็จซ้ำได้
//
// ตัวกรองประเภทจะเลือกรหัสรายการตัวแรกให้อัตโนมัติตั้งแต่เปิดหน้า
//
// ⚠️ การพิมพ์ใบเสร็จหน้านี้คิดยอด "รวมทั้งสิ้น" ต่างจากหน้าอื่น
//    (บวกเศษสตางค์ + อ่านค่าปรับจาก late_payment) — ดูคอมเมนต์ใน custom/receipt-print.js
// ============================================================

import React, { Component } from "react";
import Select from "react-select";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import { tokens, select_style, toFixed, GET, format_date, getStorage, loading, permission, Paginate, printReceiptByIwNumber } from "../../shared/index.js";

const perm = permission("capital-payment-info");

// แปลงรหัสรายการรับชำระเป็น option ของ dropdown
const payListOption = (item) => ({ value: item.code, label: `${item.code} ${item.title}` });

export default class CapitalPaymentInfo extends Component {
  state = {
    page: 1,
    filter_address_number: null,
    filter_type: null, // รหัสรายการรับชำระที่เลือกอยู่
    type: "",
    data: null,
    data_address: [],
    data_paylist: [],
  };

  async componentDidMount() {
    loading(false);
    if (perm.view) await this.GetAll();
  }

  // ---------- โหลดข้อมูล ----------

  // โหลดตัวเลือก (บ้านเลขที่ + รหัสรายการรับชำระ) แล้วค่อยโหลดตารางข้อมูล
  GetAll = async () => {
    loading(true);
    const [resCustomer, resPayList] = await Promise.all([
      GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" }),
      GET(tokens, "v1/TH/document-manage/pay-list/filter-search/page/0", null),
    ]);

    const data_address = resCustomer?.status ? resCustomer.data.data.map((item) => ({ value: item.address_number, label: `อาคาร ${item.building} ห้อง ${item.address_number}` })) : [];
    const data_paylist = resPayList?.status ? resPayList.data.data : [];
    // เลือกรหัสรายการตัวแรกให้อัตโนมัติ (หน้านี้ต้องเลือกประเภทเสมอ)
    const filter_type = data_paylist.length ? payListOption(data_paylist[0]) : null;

    this.setState({ data_address, data_paylist, filter_type }, this.GetDataAll);
  };

  GetDataAll = async () => {
    loading(true);
    const { page, filter_address_number, filter_type } = this.state;
    const result = await GET(tokens, `v1/TH/record-receipt/bill-funds/filter-search/page/${page}/${getStorage("project_id")}`, {
      address_number: filter_address_number?.value || "",
      type: filter_type?.value || "",
    });
    if (result?.status) this.setState({ data: result.data, type: filter_type?.label || "" });
    loading(false);
  };

  // รีเซ็ตตัวกรอง — ประเภทกลับไปเป็นรหัสรายการตัวแรก ไม่ใช่ค่าว่าง
  resetFilter = () => {
    this.setState(
      {
        filter_address_number: null,
        filter_type: this.state.data_paylist.length ? payListOption(this.state.data_paylist[0]) : null,
        page: 1,
      },
      this.GetDataAll
    );
  };

  render() {
    const { data, data_address, data_paylist, filter_address_number, filter_type, page } = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="ข้อมูลการรับชำระเงินทุน" />

        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              <h4 className="mb-3">
                <b>ข้อมูลการรับชำระเงินทุน</b>
              </h4>

              {/* ตัวกรอง */}
              {perm.view && (
                <div className="d-flex align-items-center mb-3">
                  <Select className="bg-contain border-0 select-search wpx-200 mx-1" styles={select_style} options={data_address} onChange={(e) => this.setState({ filter_address_number: e })} value={filter_address_number} />
                  <Select className="bg-contain border-0 select-search wpx-200 mx-1" styles={select_style} options={data_paylist.map(payListOption)} onChange={(e) => this.setState({ filter_type: e })} value={filter_type} />
                  <button className="btn btn-primary px-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetDataAll)}>
                    ค้นหา
                  </button>
                  <button className="btn btn-outline-primary px-3 mx-1" onClick={this.resetFilter}>
                    รีเซ็ท
                  </button>
                </div>
              )}

              {/* ตารางรายการ */}
              <div className="table-responsive">
                <table className="table table-borderless table-striped text-nowrap">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      <th>ห้องเลขที่</th>
                      <th>ชื่อ-นามสกุล</th>
                      <th>ยอดชำระ</th>
                      <th>เลขที่ใบเสร็จรับเงิน</th>
                      <th>วันที่ใบเสร็จรับเงิน</th>
                      <th>รายละเอียด</th>
                      <th className="text-center">พิมพ์</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!data?.data?.length ? (
                      <tr>
                        <td colSpan={7} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      data.data.map((item, index) => (
                        <tr key={index}>
                          <td className="text-nowrap">{item.address_number || "-"}</td>
                          <td className="text-nowrap">{item.full_name || "-"}</td>
                          <td>{toFixed(item.cost || 0)}</td>
                          <td>{item.iw_number || "-"}</td>
                          <td>{item.record_date ? format_date(item.record_date, "dd/mm/yyyy") : "-"}</td>
                          <td>{item.description || "-"}</td>
                          <td className="text-center">
                            {/* ปุ่มพิมพ์ใบเสร็จซ้ำ (ไอคอนเครื่องพิมพ์) */}
                            <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-inline-flex align-items-center justify-content-center m-0 pointer" onClick={() => printReceiptByIwNumber(item.iw_number)}>
                              <i className="icon text-primary">&#xf02f;</i>
                            </label>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <Paginate className="d-flex justify-content-between align-items-center mt-2 w-100" data={data} page={page} onChange={(value) => this.setState({ page: value }, this.GetDataAll)} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
